(function () {
  function formatMoney(cents, moneyFormat) {
    // Basic formatter fallback. Shopify themes often define Shopify.formatMoney; use it if available.
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat || '${{amount}}');
    }
    const value = (cents / 100).toFixed(2);
    return `$${value}`;
  }

  function updateShippingProgress(root, cartTotal) {
    if (!root) return;

    const t75 = parseInt(root.dataset.threshold75 || '7500', 10);
    const t150 = parseInt(root.dataset.threshold150 || '15000', 10);

    const msgEl = root.querySelector('[data-shipping-message]');
    const fillEl = root.querySelector('.shipping-progress__fill');

    const remaining75 = t75 - cartTotal;
    const remaining150 = t150 - cartTotal;

    let message = '';
    if (cartTotal < t75) {
      message = `Add <strong>${formatMoney(remaining75)}</strong> more to unlock <strong>free standard shipping</strong> (eligible orders).`;
    } else if (cartTotal < t150) {
      message =
        `<strong>Free shipping may apply</strong> at checkout (not combinable with other discounts). ` +
        `Spend <strong>${formatMoney(remaining150)}</strong> more to unlock <strong>always-free shipping</strong> on <strong>$150+</strong>.`;
    } else {
      message = `<strong>You’ve unlocked always-free standard shipping</strong> on <strong>$150+</strong>.`;
    }

    if (msgEl) msgEl.innerHTML = message;

    if (fillEl) {
      const progress = Math.max(0, Math.min(100, Math.round((cartTotal / t150) * 100)));
      fillEl.style.width = `${progress}%`;
    }
  }

  async function refreshAllShippingProgress() {
    const roots = document.querySelectorAll('[data-shipping-progress]');
    if (!roots.length) return;

    // Pull fresh cart total
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) return;
    const cart = await res.json();

    roots.forEach((root) => updateShippingProgress(root, cart.total_price));
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', refreshAllShippingProgress);

  // Many themes dispatch events; also hook into common cart updates by listening to fetch completion is too heavy.
  // This covers Dawn and many OS2.0 themes that fire "cart:refresh" or "cart:updated".
  document.addEventListener('cart:refresh', refreshAllShippingProgress);
  document.addEventListener('cart:updated', refreshAllShippingProgress);

  // Fallback: when drawer opens, refresh
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[href*="/cart"], [data-cart-drawer], button[name="checkout"], button[aria-controls*="CartDrawer"]');
    if (trigger) setTimeout(refreshAllShippingProgress, 250);
  });
})();
